import { React } from "react";
import { useSelector } from "react-redux";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";

import { AdvancedImage } from "@cloudinary/react";
import { CloudinaryImage } from "@cloudinary/url-gen";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { format, quality } from "@cloudinary/url-gen/actions/delivery";
import { autoGravity } from "@cloudinary/url-gen/qualifiers/gravity";

const Banner = () => {
  const { categorys } = useSelector((state) => state.home);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const getOptimizedImageUrl = (publicId) => {
    const cldImage = new CloudinaryImage(publicId, { cloudName: "dapninft5" })
      .delivery(format("auto")) // Automatically select best format (WebP, AVIF, etc.)
      .delivery(quality("auto:low")) // Auto optimize quality (reduces file size significantly)
      .resize(fill().width(400).height(240).gravity(autoGravity())); // Resize with auto crop
    return cldImage;
  };

  return (
    <div className="w-full bg-[whitesmoke]">
      <div className="w-[95%] lg:w-[90%] mx-auto bg-[whitesmoke]">
        <div className="w-full flex gap-3 lg:justify-center md-lg:gap-8">
          <div className="w-[90%] my-5  md:hidden lg:hidden">
            <div className="bg-white drop-shadow-md relative">
              <div className="overflow-hidden transition-all  rounded-[20px] duration-500 absolute z-[99999] bg-white w-full h-[350px] border-x">
                <h2 className=" text-[#212730] px-[24px] pt-[20px] pb-[10px] font-semibold">
                  Categories
                </h2>
                <ul className="py-2 text-slate-600 transition-all duration-500 font-medium h-full overflow-auto ">
                  {categorys.map((c, i) => (
                    <Link
                      to={`/products?category=${c.name}`}
                      key={i}
                      className="flex justify-start items-center rounded-[10px] gap-2 px-[24px] py-[6px] hover:bg-green-100 hover:font-semibold hover:text-secondary"
                    >
                      <AdvancedImage
                        className="w-[30px] h-[30px] rounded-full overflow-hidden"
                        cldImg={getOptimizedImageUrl(
                          c.image
                            .split("/")
                            .slice(-2)
                            .join("/")
                            .replace(/\.[^.]+$/, "")
                        )}
                        alt="image"
                      />
                      {/* <img
                        src={c.image}
                        className="w-[30px] h-[30px] rounded-full overflow-hidden"
                        alt={c.name}
                      /> */}
                      <p className="text-sm block ">{c.name}</p>
                    </Link>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="w-[80%] md:w-[100%] lg:w-[80%]">
            <div className="my-5 drop-shadow-md rounded-[10px]">
              <div className="absolute z-20 w-full bg-black/[.3] h-full rounded-[20px] text-white font-bold text-5xl md:text-3xl sm:text-xl text-center flex flex-col gap-3 items-center justify-center">
                <h1 className=" text-white font-bold  text-center flex items-center justify-center ">
                  Bringing You the Best,{" "}
                </h1>
                <span className="text-secondary flex items-center gap-2">
                  {" "}
                  Every Day<p className="animate-bounce mt-1">!</p>
                </span>
              </div>
              <div className="md:hidden lg:hidden">
                <Carousel
                  className="rounded-[20px]"
                  autoPlay={true}
                  infinite={true}
                  autoPlaySpeed={5000}
                  arrows={false}
                  showDots={false}
                  responsive={responsive}
                >
                  {[1, 2, 3].map((img, i) => (
                    <div
                      className="lg:h-auto md:h-auto h-[350px] w-full  block"
                      key={i}
                      to="#"
                    >
                      <img
                        className="object-cover w-full h-full "
                        src={`/images/banner/${img}.jpg`}
                        alt=""
                      />
                    </div>
                  ))}
                </Carousel>
              </div>
              <div className="md:block lg:block hidden ">
                <Carousel
                  className="rounded-[20px]"
                  autoPlay={false}
                  infinite={false}
                  autoPlaySpeed={5000}
                  arrows={false}
                  showDots={false}
                  responsive={responsive}
                >
                  {[5].map((img, i) => (
                    <div
                      className="lg:h-auto md:h-auto  h-[350px] w-full  block"
                      key={i}
                      to="#"
                    >
                      <img
                        className="object-cover w-full h-full "
                        src={`/images/banner/${img}.jpg`}
                        alt=""
                      />
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
